import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { formatError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { login, register } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || "/area-socio";
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ name: "", email: "", password: "", phone: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      if (mode === "login") {
        const logged = await login(form.email, form.password);
        toast.success("Bienvenido de nuevo");
        navigate(logged.role === "admin" ? "/admin" : from, { replace: true });
      } else {
        await register({ name: form.name, email: form.email, password: form.password, phone: form.phone || undefined });
        toast.success("Cuenta creada. ¡Bienvenido al club!");
        navigate(from, { replace: true });
      }
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="relative min-h-[85vh] flex items-center" data-testid="login-page">
      <div className="absolute inset-0">
        <img src="https://images.unsplash.com/photo-1636915739119-1ef2fe0b87d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHw0fHxkZWVyJTIwZm9yZXN0fGVufDB8fHx8fDE3ODYwOTgwODh8MA&ixlib=rb-4.1.0&q=85" alt="Bosque" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/70" />
      </div>
      <div className="relative max-w-md w-full mx-auto px-5 py-20">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
          className="bg-carbon/85 backdrop-blur-xl border border-white/10 p-8 lg:p-10">
          <p className="font-heading text-2xl text-white text-center">CINEGÉTICA <span className="text-gold">RUTA DEL AGUA</span></p>
          <p className="mt-2 text-center text-[9px] uppercase tracking-[0.25em] text-sand">Club de Caza · Guillena</p>
          <div className="mt-8 grid grid-cols-2 border border-white/10">
            <button onClick={() => setMode("login")}
              className={`py-3 text-[11px] uppercase tracking-[0.15em] font-semibold transition-colors duration-200 ${mode === "login" ? "bg-gold text-black" : "text-white/50 hover:text-white"}`}
              data-testid="tab-login">
              Acceder
            </button>
            <button onClick={() => setMode("register")}
              className={`py-3 text-[11px] uppercase tracking-[0.15em] font-semibold transition-colors duration-200 ${mode === "register" ? "bg-gold text-black" : "text-white/50 hover:text-white"}`}
              data-testid="tab-register">
              Crear Cuenta
            </button>
          </div>
          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="auth-form">
            {mode === "register" && (
              <>
                <input className="input-dark" placeholder="Nombre completo" required value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="auth-name" />
                <input className="input-dark" placeholder="Teléfono (opcional)" value={form.phone}
                  onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="auth-phone" />
              </>
            )}
            <input className="input-dark" type="email" placeholder="Email" required value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="auth-email" />
            <input className="input-dark" type="password" placeholder="Contraseña (mín. 6 caracteres)" required minLength={6} value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="auth-password" />
            <button type="submit" disabled={busy} className="btn-gold-solid w-full disabled:opacity-40" data-testid="auth-submit">
              {busy ? "Procesando..." : mode === "login" ? "Entrar" : "Crear Cuenta"}
            </button>
          </form>
          <p className="mt-6 text-center text-white/40 text-xs font-light">
            {mode === "login" ? "¿Aún no tienes cuenta? " : "¿Ya tienes cuenta? "}
            <button onClick={() => setMode(mode === "login" ? "register" : "login")} className="text-gold underline underline-offset-4" data-testid="auth-switch-mode">
              {mode === "login" ? "Regístrate" : "Accede"}
            </button>
          </p>
          <p className="mt-4 text-center"><Link to="/" className="text-white/30 hover:text-gold text-xs transition-colors" data-testid="back-home">← Volver al inicio</Link></p>
        </motion.div>
      </div>
    </div>
  );
}
